import { useEffect, useState } from 'react';

export type ReportApiTrackerState = {
    total: number;
    failed: number;
    succeeded: number;
    inflight: number;
};

let state: ReportApiTrackerState = { total: 0, failed: 0, succeeded: 0, inflight: 0 };
const listeners = new Set<(s: ReportApiTrackerState) => void>();

const emit = () => {
    const snapshot = { ...state };
    listeners.forEach((fn) => {
        try { fn(snapshot); } catch { /* ignore */ }
    });
};

export const reportApiTracker = {
    trackStart() {
        state = {
            ...state,
            total: state.total + 1,
            inflight: state.inflight + 1,
        };
        emit();
    },
    trackSuccess() {
        state = {
            ...state,
            inflight: Math.max(0, state.inflight - 1),
            succeeded: state.succeeded + 1,
        };
        emit();
    },
    trackFailure() {
        state = {
            ...state,
            inflight: Math.max(0, state.inflight - 1),
            failed: state.failed + 1,
        };
        emit();
    },
    reset() {
        state = { total: 0, failed: 0, succeeded: 0, inflight: 0 };
        emit();
    },
    getState(): ReportApiTrackerState {
        return state;
    },
    subscribe(fn: (s: ReportApiTrackerState) => void) {
        listeners.add(fn);
        return () => { listeners.delete(fn); };
    },
};

export const useReportApiTrackerState = (): ReportApiTrackerState => {
    const [snapshot, setSnapshot] = useState<ReportApiTrackerState>(() => reportApiTracker.getState());
    useEffect(() => reportApiTracker.subscribe(setSnapshot), []);
    return snapshot;
};
